import * as React from 'react';
import styled from 'styled-components';
import OCContext from '../OCContext';
import { Customer } from '../domain/customer/Customer';
import fireCustomerCloseEvent from '../event/customerCloseEvent';
import {
  TYPE as WINDOW_CLOSE_EVENT_TYPE,
  WindowCloseEventData,
  WindowCloseEventDataType,
} from '../event/window_close_event';
import AddCustormForm from './form/customer/FormCustomerAdd';
import { IconClose } from './icon/IconClose';
import ArrowMenuCustomerSearch from './menu/ArrowMenuUserSearch';
import Popup from './popup/Popup';

const WINDOW_ID = 'customers';

const Table = styled.div`
  display: table;
  height: 100%;
  position: relative;
  vertical-align: middle;
`;

const Cell = styled.div`
  display: table-cell;
  height: 100%;
  position: relative;
  vertical-align: middle;

  & *:hover {
    cursor: pointer;
  }
`;

const Inner = styled.label`
  border-radius: 0.2rem;
  display: table;
  font-weight: bold;
  letter-spacing: 0.02rem;
  padding: 0.25rem 0.6rem;
  user-select: none;
`;

const IcoPanel = styled.div`
  display: block;
  height: 1.2rem;
  padding-left: 0.5rem;
  width: 1.2rem;
`;

const LabelCustomer = styled.label`
  display: table-cell;
  font-weight: bold;
  vertical-align: middle;
`;

const CustomerButton = () => {
  const { customer, setCustomer } = React.useContext(OCContext);
  const [showSearchForm, setShowSearchForm] = React.useState(false);
  const [showAddForm, setShowAddForm] = React.useState(false);

  React.useEffect(() => {
    const onCustomerOpen = () => setShowSearchForm(false);
    const onCustomerAdded = (e: Event & { data: Customer }) => {
      setShowAddForm(false);
      setCustomer(e.data);
    };

    document.body.addEventListener('customer_open', onCustomerOpen);
    document.body.addEventListener('customer_added', onCustomerAdded);

    // cleanup this component
    return () => {
      document.body.removeEventListener('customer_open', onCustomerOpen);
      document.body.removeEventListener('customer_added', onCustomerAdded);
    };
  }, []);

  const openMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowSearchForm(!showSearchForm);
    window.addEventListener('click', closeMenu);
    if (!showSearchForm) {
      const ev = new CustomEvent<WindowCloseEventData>(
        WINDOW_CLOSE_EVENT_TYPE,
        {
          detail: {
            window_id: WINDOW_ID,
            type: WindowCloseEventDataType.NAV_TOP,
          },
        }
      );
      document.dispatchEvent(ev);
    }
  };

  const closeMenu = () => {
    setShowSearchForm(false);
    window.removeEventListener('click', closeMenu);
  };

  const openCustomerAddForm = () => {
    closeMenu();
    setShowAddForm(true);
  };

  const clearCustomer = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCustomer(null);
    fireCustomerCloseEvent();
  };

  const getBtnText = () => {
    if (customer) {
      const name = customer.name_first;
      if (customer.name_first && customer.name_last) {
        return `${customer.name_first} ${customer.name_last}`;
      }

      if (customer.name_first) {
        return customer.name_first;
      }

      return customer.customer_id;
    }

    return 'Customer';
  };

  return (
    <>
      <Table>
        <Cell>
          <Inner
            className="site-header__customer-management-btn"
            onClick={(e: React.MouseEvent) => openMenu(e)}
          >
            <LabelCustomer>{getBtnText()}</LabelCustomer>
            {customer ? (
              <IcoPanel>
                <IconClose onClick={clearCustomer} />
              </IcoPanel>
            ) : null}
          </Inner>
          {showSearchForm ? (
            <ArrowMenuCustomerSearch
              openCustomerAddForm={openCustomerAddForm}
            />
          ) : null}
        </Cell>
      </Table>

      {showAddForm ? (
        <Popup onClose={() => setShowAddForm(false)} title="Add Customer">
          <AddCustormForm />
        </Popup>
      ) : null}
    </>
  );
};

export default CustomerButton;
